<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日程标题">
              <a-input placeholder="请输入日程标题" v-model="queryParam.title" allowClear />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划类型">
              <a-select placeholder="请选择计划类型" v-model="queryParam.type" allowClear>
                <a-select-option v-for="item in planTypeOptions" :key="item.value" :value="item.value">
                  {{ item.text || item.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <!-- <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="提醒类型">
              <j-dict-select-tag
                placeholder="请选择提醒类型"
                dictCode="remind_type"
                v-model="queryParam.remindType"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col> -->

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开始时间">
              <a-range-picker
                format="YYYY-MM-DD"
                v-model="dates.startTime"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateStartTime"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结束时间">
              <a-range-picker
                format="YYYY-MM-DD"
                v-model="dates.endTime"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateEndTime"
              />
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设施类型">
              <j-dict-select-tag
                placeholder="请选择设施类型"
                dictCode="operation_type"
                v-model="queryParam.operationType"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>


            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="执行人">
                <a-input placeholder="请输入执行人" v-model="queryParam.executorNames" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                <j-dict-select-tag
                  placeholder="请选择状态"
                  dictCode="plan_status"
                  v-model="queryParam.status"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <work-plan-query-toggle v-if="isAdmin" :checked="queryAll" @change="changeQueryAll" />
      <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
      <a-button @click="searchReset" icon="reload">重置</a-button>
      <a-button type="dashed" @click="handleToggleSearch" style="margin-left: 15px; margin-right: 50px"
      >{{ toggleSearchStatus ? '收起' : '展开' }}
        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"
        />
      </a-button>
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!--<a-button icon="download" @click="handleExportXls()">导出</a-button>
            <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="handleImportFile" @change="handleImportExcel">
                <a-button  type="danger" icon="import" ghost>导入</a-button>
            </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="planTitle" slot-scope="text, record">
          <a
            @click="handleDetail(record)"
            class="plan-title-link"
            :title="text"
          >
            {{ text || '无标题日程' }}
          </a>
        </span>
        <span slot="type" slot-scope="text, record">
          <a-tag :color="record.type === '10' ? 'purple' : 'blue'">
            {{ record.type_dictText || (record.type === '10' ? '周期计划' : '人工创建') }}
          </a-tag>
        </span>
        <span slot="facility" slot-scope="text, record" :title="record.siteName">
          <a-tag size="small" :color="record.operationType == '2' ? 'cyan' : 'blue'" style="margin-right: 4px;">
            {{ record.operationType_dictText || (record.operationType == '2' ? '管网' : '站点') }}
          </a-tag>
          <span style="font-weight: 500; color: #333;">{{ record.siteName || '-' }}</span>
        </span>
        <span slot="planPeriod" slot-scope="text, record">
          <div style="font-size: 12px; color: #555; line-height: 1.6;">
            <a-icon type="clock-circle" style="color: #1890ff; margin-right: 4px;" />始：{{ formatPeriodTime(record.startTime) }}
          </div>
          <div style="font-size: 12px; color: #555; line-height: 1.6;">
            <a-icon type="clock-circle" style="color: #fa8c16; margin-right: 4px;" />止：{{ formatPeriodTime(record.endTime) }}
            <a-tag v-if="isOverdue(record)" color="red" style="transform: scale(0.85); margin-left: 2px;">已逾期</a-tag>
          </div>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="record.status == 2 ? 'green' : 'orange'">
            {{ record.status_dictText || (record.status == 2 ? '已完成' : '未完成') }}
          </a-tag>
        </span>
        <span slot="completedInfo" slot-scope="text, record">
          <template v-if="record.status == 2">
            <div style="font-weight: 500; color: #333;">{{ record.completedUserName || '-' }}</div>
            <div style="font-size: 12px; color: #888;" v-if="record.completeTime">{{ formatPeriodTime(record.completeTime) }}</div>
          </template>
          <span v-else style="color: #999;">-</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a
            @click="handleDetail(record)"
            :style="canProcess(record) ? 'font-weight: 600; color: #1890ff;' : ''"
          >
            {{ canProcess(record) ? '去处理' : '详情' }}
          </a>
          <template v-if="record.type !== '10'">
            <a-divider type="vertical"/>
            <a @click="handleEdit(record)" v-if="canEdit(record)">编辑</a>
            <span v-else style="color: #bbb; cursor: not-allowed;" :title="getEditDisabledTitle(record)">编辑</span>
            <template v-if="getAuth(record.createBy)">
              <a-divider type="vertical"/>
              <a-popconfirm v-if="canDelete(record)" title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
              <span v-else style="color: #bbb; cursor: not-allowed;" title="已有项目执行完成，不可删除">删除</span>
            </template>
          </template>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <work-plan-modal ref="modalForm" :pagePath="pagePath" @ok="modalFormOk"></work-plan-modal>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WorkPlanQueryMixin from './WorkPlanQueryMixin'
  import WorkPlanQueryToggle from './modules/WorkPlanQueryToggle.vue'
  import WorkPlanModal from './modules/WorkPlanModal.vue'
  import { getWorkPlanTypes } from '@/api/api'
  import moment from 'moment'

  export default {
    name: 'WorkPlanList',
    mixins: [JeecgListMixin, WorkPlanQueryMixin],
    components: {
      WorkPlanQueryToggle,
      WorkPlanModal
    },
    data() {
      return {
        pagePath: '/om/work/plan',
        pageTitle: '工作计划',
        isorter: {
          column: 'create_time',
          order: 'desc'
        },
        projectCode:'',
        planTypeOptions: [],
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key: 'rowIndex',
            width: 50,
            align: 'center',
            customRender: function(t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '日程标题',
            dataIndex: 'title',
            colName: 'title',
            align: 'left',
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'planTitle' }
          },
          {
            title: '计划类型',
            dataIndex: 'type',
            colName: 'type',
            width: 90,
            align: 'center',
            scopedSlots: { customRender: 'type' }
          },
          {
            title: '设施/站点',
            dataIndex: 'siteName',
            colName: 'siteName',
            align: 'left',
            width: 170,
            ellipsis: true,
            scopedSlots: { customRender: 'facility' }
          },
          {
            title: '日程周期',
            dataIndex: 'startTime',
            colName: 'start_time',
            align: 'left',
            width: 180,
            sorter: true,
            scopedSlots: { customRender: 'planPeriod' }
          },
          {
            title: '执行人',
            dataIndex: 'executorNames',
            colName: 'executor_names',
            align: 'center',
            width: 130,
            ellipsis: true,
            customRender: (text) => text || '-'
          },
          {
            title: '状态',
            dataIndex: 'status',
            colName: 'status',
            width: 80,
            align: 'center',
            scopedSlots: { customRender: 'status' }
          },
          {
            title: '创建人',
            dataIndex: 'createBy_userName',
            colName: 'create_by',
            align: 'center',
            width: 90,
            customRender: (text) => text || '-'
          },
          {
            title: '完成信息',
            dataIndex: 'completedUserName',
            colName: 'completed_user_name',
            align: 'center',
            width: 140,
            scopedSlots: { customRender: 'completedInfo' }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 175,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    created() {
      if(window.localStorage.getItem('projectCode')){
        this.projectCode = window.localStorage.getItem('projectCode')
      }
      if(this.projectCode=='meitang'){
        this.columns = this.columns.filter(col => col.dataIndex !== 'completedUserName')
      }
      this.initPlanTypes()
    },
    computed: {},
    methods: {
      initPlanTypes() {
        getWorkPlanTypes().then(res => {
          if (res && res.success && Array.isArray(res.result) && res.result.length > 0) {
            this.planTypeOptions = res.result
          } else {
            this.fallbackPlanTypes()
          }
        }).catch(() => {
          this.fallbackPlanTypes()
        })
      },
      fallbackPlanTypes() {
        this.planTypeOptions = [
          { value: '1', title: '人工创建', text: '人工创建' },
          { value: '10', title: '周期计划', text: '周期计划' }
        ]
      },
      onDateReminderTime: function(value, dateArray) {
        this.queryParam.reminderTimeStart = dateArray[0]
        this.queryParam.reminderTimeEnd = dateArray[1]
      },
      onDateStartTime: function(value, dateArray) {
        this.queryParam.startTimeStart = dateArray[0]
        this.queryParam.startTimeEnd = dateArray[1]
      },
      onDateEndTime: function(value, dateArray) {
        this.queryParam.endTimeStart = dateArray[0]
        this.queryParam.endTimeEnd = dateArray[1]
      },
      formatPeriodTime(timeStr) {
        if (!timeStr) return '-'
        return timeStr.length > 16 ? timeStr.substring(0, 16) : timeStr
      },
      isOverdue(record) {
        if (!record || record.status == 2 || !record.endTime) return false
        return moment(record.endTime).isBefore(moment())
      },
      canProcess(record) {
        if (!record || record.status == 2) return false
        const user = this.$store.getters.userInfo
        if (!user || !user.id) return false
        if (record.createBy == user.id) return true
        if (record.executorIds && Array.isArray(record.executorIds)) {
          if (record.executorIds.includes(user.id) || record.executorIds.includes(Number(user.id))) return true
        }
        if (record.executorNames && user.realname) {
          if (record.executorNames.split(',').includes(user.realname)) return true
        }
        return false
      },
      handleDetail(record) {
        const isProcess = this.canProcess(record)
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = isProcess ? `处理日程：${record.title || ''}` : `日程详情：${record.title || ''}`
        this.$refs.modalForm.disableSubmit = true
      },
      canEdit(record) {
        if (!record || record.status == 2 || record.status === '2') return false
        if (record.workPlanDetailList && Array.isArray(record.workPlanDetailList)) {
          return !record.workPlanDetailList.some(d => d.status == 2 || d.status === '2')
        }
        return true
      },
      canDelete(record) {
        if (!record || record.status == 2 || record.status === '2') return false
        if (record.workPlanDetailList && Array.isArray(record.workPlanDetailList)) {
          return !record.workPlanDetailList.some(d => d.status == 2 || d.status === '2')
        }
        return true
      },
      getEditDisabledTitle(record) {
        if (record && (record.status == 2 || record.status === '2')) {
          return '已完成日程不可编辑'
        }
        return '已有项目执行完成，不可编辑'
      },
      handleEdit(record) {
        if (!this.canEdit(record)) {
          this.$message.warning(this.getEditDisabledTitle(record))
          return
        }
        this.$refs.modalForm.title = '编辑：' + this.pageTitle
        this.$refs.modalForm.disableSubmit = false
        this.$refs.modalForm.showTab = true
        this.$refs.modalForm.showContact = true
        this.$refs.modalForm.edit(record)
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';

  .table-operator .plan-query-toggle {
    margin-right: 12px;
  }

  .plan-title-link {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    transition: color 0.2s ease;
  }
  .plan-title-link:hover {
    color: #1890ff !important;
    text-decoration: underline;
  }
</style>
